export const ORBITS = {
  LEO: 'LEO',
  MEO: 'MEO',
  GEO: 'GEO',
  HEO: 'HEO',
  VLEO: 'VLEO',
  SSO: 'SSO',
  PEO: 'PEO',
  RCO: 'RCO',
  GTO: 'GTO',
  SGTO: 'SGTO',
  MDO: 'MDO',
  SSTO: 'SSTO',
  GDO: 'GDO',
  GSO: 'GSO',
  SDO: 'SDO',
  FEO: 'FEO',
  OTHER: 'OTHER',
} as const;
export type Orbit = (typeof ORBITS)[keyof typeof ORBITS];

export type EarthOrbitDescription =
  | 'apogee'
  | 'perigee'
  | 'inclination'
  | 'accuracy'
  | 'raan'
  | 'perigeeArgument'
  | 'epoch'
  | 'meanAnomalyAtEpoch';

const EarthOrbitFields: EarthOrbitDescription[] = [
  'apogee',
  'perigee',
  'inclination',
  'accuracy',
  'raan',
  'perigeeArgument',
  'epoch',
  'meanAnomalyAtEpoch',
];

// Created as a mapping before changes, it will still be useful when adding lunar orbits
const ORBIT_FIELDS: Record<Orbit, EarthOrbitDescription[]> = {
  LEO: EarthOrbitFields,
  VLEO: EarthOrbitFields,
  PEO: EarthOrbitFields,
  RCO: EarthOrbitFields,
  GTO: EarthOrbitFields,
  SGTO: EarthOrbitFields,
  SSTO: EarthOrbitFields,
  FEO: EarthOrbitFields,

  MEO: EarthOrbitFields,
  GDO: EarthOrbitFields,

  HEO: EarthOrbitFields,
  GEO: EarthOrbitFields,
  SSO: EarthOrbitFields,
  MDO: EarthOrbitFields,
  GSO: EarthOrbitFields,
  SDO: EarthOrbitFields,
  OTHER: EarthOrbitFields,
};

export const ORBIT_FIELD_FLAGS: Record<Orbit, Record<EarthOrbitDescription, boolean>> = Object.fromEntries(
  Object.entries(ORBIT_FIELDS).map(([orbit, fields]) => [
    orbit,
    {
      apogee: false,
      perigee: false,
      inclination: false,
      accuracy: false,
      raan: false,
      perigeeArgument: false,
      epoch: false,
      meanAnomalyAtEpoch: false,
      ...Object.fromEntries(fields.map(f => [f, true])),
    },
  ]),
) as Record<Orbit, Record<EarthOrbitDescription, boolean>>;
